import { render, staticRenderFns } from "./SelectProjects.vue?vue&type=template&id=793bddc2&scoped=true&"
import script from "./SelectProjects.vue?vue&type=script&lang=ts&"
export * from "./SelectProjects.vue?vue&type=script&lang=ts&"
import style0 from "./SelectProjects.vue?vue&type=style&index=0&id=793bddc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bddc2",
  null
  
)

export default component.exports